export interface RankItem {
  rank: number;
  title: string;
  kind: string;
  year: string;
  rating: number;
  reason: string;
  tags: string[];
}

export const editorPicks: RankItem[] = [
  {
    rank: 1,
    title: '山海图志',
    kind: '电影',
    year: '2025',
    rating: 9.1,
    reason: '把东方志怪的想象力画进了银幕，画面与音乐都值得反复回味。',
    tags: ['动画', '奇幻'],
  },
  {
    rank: 2,
    title: '远山有灯',
    kind: '电视剧',
    year: '2025',
    rating: 9.0,
    reason: '节奏不急不缓，用一家人的日常写出了几十年的时代变迁。',
    tags: ['年代', '家庭'],
  },
  {
    rank: 3,
    title: '星轨之外',
    kind: '电影',
    year: '2025',
    rating: 8.9,
    reason: '硬科幻的外壳下包着一个关于回家的柔软故事，特效与情感都在线。',
    tags: ['科幻', '冒险'],
  },
  {
    rank: 4,
    title: '青川志异',
    kind: '电视剧',
    year: '2026',
    rating: 8.8,
    reason: '单元故事与主线交织，美术风格统一，越看越有味道。',
    tags: ['古装', '奇幻'],
  },
  {
    rank: 5,
    title: '雾都迷案',
    kind: '电视剧',
    year: '2026',
    rating: 8.7,
    reason: '悬念铺得稳，反转不刻意，人物动机经得起推敲。',
    tags: ['悬疑', '犯罪'],
  },
  {
    rank: 6,
    title: '厨房里的人生',
    kind: '电视剧',
    year: '2025',
    rating: 8.6,
    reason: '一部适合深夜观看的治愈剧，每一集都像吃了一顿热乎的饭。',
    tags: ['美食', '治愈'],
  },
  {
    rank: 7,
    title: '荒野拾光',
    kind: '电影',
    year: '2026',
    rating: 8.6,
    reason: '纪录片式的克制镜头，把荒原的辽阔与人心的温度一起拍了出来。',
    tags: ['剧情', '冒险'],
  },
  {
    rank: 8,
    title: '无声之城',
    kind: '电影',
    year: '2025',
    rating: 8.5,
    reason: '用“失去声音”的设定讲了一个关于倾听的故事，氛围营造一流。',
    tags: ['悬疑', '惊悚'],
  },
];